import { z } from "zod";
import api from "@/infrastructure/api/axios";
import { isPrivateProviderContext, privateManagementList, } from "@/services/admin/private-provider-management";
import { chargeTemplateSchema, } from "../models/charge-template.schema";
// =============================================================================
// IMPLEMENTATION
// =============================================================================
const GLOBAL_CONFIG = { orgContext: "global" };
export const chargeTemplateRepository = {
    async getAll() {
        if (isPrivateProviderContext()) {
            const response = await privateManagementList("charges/templates");
            const rows = z
                .array(chargeTemplateSchema.extend({
                amount: z.object({
                    amount_minor_units: z.number().int().nonnegative().safe(),
                    currency: z.literal("USD"),
                }),
            }))
                .parse(response.data);
            // Adapt main's V2 money response to the existing service form contract.
            return rows.map((row) => ({
                ...row,
                amount: row.amount.amount_minor_units / 100,
            }));
        }
        const response = await api.get("/admin/charges/templates", GLOBAL_CONFIG);
        return z.array(chargeTemplateSchema).parse(response.data);
    },
    async create(dto) {
        const response = await api.post("/admin/charges/templates", dto, GLOBAL_CONFIG);
        return chargeTemplateSchema.parse(response.data);
    },
    async update(id, dto) {
        const response = await api.patch(`/admin/charges/templates/${id}`, dto, GLOBAL_CONFIG);
        return chargeTemplateSchema.parse(response.data);
    },
    async delete(id) {
        await api.delete(`/admin/charges/templates/${id}`, GLOBAL_CONFIG);
    },
};
export default chargeTemplateRepository;
